import * as React from 'react';
import { classNames } from '@egds/react-core/utils';
export var SecondaryHeaderRegion = function (props) {
    var className = props.className, children = props.children;
    var classes = classNames('secondary-header-region', className);
    return React.createElement("section", { className: classes }, children);
};
//# sourceMappingURL=secondary-header-region.js.map